<template>
  <div class="navbar-container d-flex content align-items-center">
    <!-- Nav Menu Toggler -->
    <ul class="nav navbar-nav d-xl-none">
      <li class="nav-item">
        <b-link
          class="nav-link"
          @click="toggleVerticalMenuActive"
        >
          <feather-icon
            icon="MenuIcon"
            size="21"
          />
        </b-link>
      </li>
    </ul>

    <!-- Left Col -->
    <div class="bookmark-wrapper align-items-center flex-grow-1 d-none d-lg-flex">
      <!-- <dark-Toggler class="d-none d-lg-block" /> -->
    </div>

    <b-navbar-nav
      v-if="user"
      class="nav align-items-center ml-auto"
    >
      <li
        v-if="canDownloadApk"
        class="nav-item mr-50"
      >
        <b-link
          :href="apkUrl"
          download="team-parcel-express.apk"
          class="nav-link apk-download-link"
          aria-label="Télécharger l'application Android"
          title="Télécharger l'APK"
        >
          <feather-icon
            icon="DownloadIcon"
            size="18"
          />
          <span>APK</span>
        </b-link>
      </li>

      <!-- Notification Dropdown -->
      <b-nav-item-dropdown
        v-if="canViewSupportNotifications"
        class="dropdown-notification mr-25"
        menu-class="dropdown-menu-media"
        right
        @show="fetchSupportNotifications(true)"
      >
        <template #button-content>
          <feather-icon
            :badge="totalNotificationCount || null"
            badge-classes="bg-danger"
            class="text-body"
            icon="BellIcon"
            size="21"
          />
        </template>

        <!-- Header -->
        <li class="dropdown-menu-header">
          <div class="dropdown-header d-flex align-items-center">
            <h4 class="notification-title mb-0 mr-auto">
              Notifications
            </h4>
            <b-badge
              v-if="totalNotificationCount > 0"
              pill
              variant="light-primary"
            >
              {{ totalNotificationCount }} nouveau{{ totalNotificationCount > 1 ? 'x' : '' }}
            </b-badge>
          </div>
        </li>

        <!-- Notifications -->
        <vue-perfect-scrollbar
          :settings="perfectScrollbarSettings"
          class="scrollable-container media-list scroll-area"
          tagname="li"
        >
          <div
            v-if="notificationLoading"
            class="notification-empty"
          >
            Chargement...
          </div>

          <div
            v-else-if="supportNotifications.length === 0 && inventoryNotifications.length === 0 && direxNotifications.length === 0"
            class="notification-empty"
          >
            Aucune nouvelle notification
          </div>

          <template v-else>
            <b-link v-for="notification in direxNotifications" :key="notification.id" class="notification-item d-flex align-items-start direx-notification" @click.prevent="openDirexNotification"><div class="notification-icon direx-notification-icon"><feather-icon icon="AlertTriangleIcon" size="18" /></div><div class="notification-body"><div class="notification-heading">{{ notification.title }}</div><div class="notification-text">{{ notification.message }}</div><div class="notification-meta"><span>{{ notification.meta }}</span></div></div></b-link>
            <b-link
              v-for="notification in inventoryNotifications"
              :key="notification.id"
              class="notification-item d-flex align-items-start inventory-notification"
              @click.prevent="openInventoryNotification"
            >
              <div class="notification-icon inventory-notification-icon">
                <feather-icon
                  icon="AlertTriangleIcon"
                  size="18"
                />
              </div>
              <div class="notification-body">
                <div class="notification-heading">
                  {{ notification.title }}
                </div>
                <div class="notification-text">
                  {{ notification.message }}
                </div>
                <div class="notification-meta">
                  <span>{{ notification.meta }}</span>
                </div>
              </div>
            </b-link>

            <b-link
              v-for="notification in supportNotifications"
              :key="notification.id"
              class="notification-item d-flex align-items-start"
              @click.prevent="openSupportNotification(notification)"
            >
              <div class="notification-icon">
                <feather-icon
                  icon="FileTextIcon"
                  size="18"
                />
              </div>
              <div class="notification-body">
                <div class="notification-heading">
                  {{ notification.title }}
                </div>
                <div class="notification-text">
                  {{ notification.message }}
                </div>
                <div class="notification-meta">
                  <span v-if="notification.ticket_title">
                    {{ truncateText(notification.ticket_title, 42) }}
                  </span>
                  <span>{{ formatFn(notification.created_at) }}</span>
                </div>
              </div>
            </b-link>
          </template>
        </vue-perfect-scrollbar>
      </b-nav-item-dropdown>

      <!-- User Dropdown -->
      <b-nav-item-dropdown
        right
        toggle-class="d-flex align-items-center dropdown-user-link"
        class="dropdown-user"
      >
        <template #button-content>
          <div class="d-sm-flex user-nav">
            <p class="user-name font-weight-bolder mb-0">
              {{ user.username }}
            </p>
            <span class="user-status">{{ formatRole(user.role) }}</span>
          </div>
          <b-avatar
            size="40"
            variant="light-primary"
            badge
            :src="require('@/assets/images/avatars/13-small.png')"
            class="badge-minimal"
            badge-variant="success"
          />
        </template>

        <b-dropdown-item
          :to="{ name:'profile' }"
          link-class="d-flex align-items-center"
        >
          <feather-icon
            size="16"
            icon="UserIcon"
            class="mr-50"
          />
          <span>Profil</span>
        </b-dropdown-item>

        <b-dropdown-item
          v-if="canDownloadApk"
          :href="apkUrl"
          download="team-parcel-express.apk"
          link-class="d-flex align-items-center"
        >
          <feather-icon
            size="16"
            icon="DownloadIcon"
            class="mr-50"
          />
          <span>Télécharger l'APK</span>
        </b-dropdown-item>

        <b-dropdown-divider />

        <b-dropdown-item
          :to="{ name:'logout' }"
          link-class="d-flex align-items-center"
        >
          <feather-icon
            size="16"
            icon="LogOutIcon"
            class="mr-50"
          />
          <span>Se déconnecter</span>
        </b-dropdown-item>
      </b-nav-item-dropdown>

    </b-navbar-nav>
  </div>
</template>

<script>
import {
  BLink, BNavbarNav, BNavItemDropdown, BDropdownItem, BDropdownDivider, BAvatar,
  BBadge,
} from 'bootstrap-vue'
import storeAuth from '@/store/store'
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import Ripple from 'vue-ripple-directive'
import axios from 'axios'

export default {
  components: {
    BLink,
    BNavbarNav,
    BNavItemDropdown,
    BDropdownItem,
    BDropdownDivider,
    BAvatar,
    BBadge,
    VuePerfectScrollbar,
  },
  directives: {
    Ripple,
  },
  props: {
    toggleVerticalMenuActive: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      user: null,
      notificationLoading: false,
      supportNotifications: [],
      direxInvoices: [],
      inventoryReminder: null,
      notificationPoller: null,
      apkAvailable: false,
      number: 0,
    }
  },
  computed: {
    storeUser() {
      return storeAuth.state.user
    },
    canDownloadApk() {
      const role = this.user?.role || storeAuth.state.role || localStorage.getItem('role')
      return this.apkAvailable && ['admin', 'superadmin'].includes(role)
    },
    apkUrl() {
      const baseUrl = process.env.BASE_URL || '/'
      const normalizedBaseUrl = baseUrl.endsWith('/') ? baseUrl : `${baseUrl}/`
      return `${normalizedBaseUrl}apk/team-parcel-express.apk`
    },
    canViewSupportNotifications() {
      if (!this.user) return false

      const supportNotificationRoles = ['admin', 'superadmin', 'manager', 'customer_support', 'supplier']
      return supportNotificationRoles.includes(this.user.role)
    },
    canViewInventoryNotifications() {
      if (!this.user) return false
      return ['admin', 'superadmin'].includes(this.user.role)
    },
    canViewDirexNotifications() { return !!this.user && ['admin', 'superadmin'].includes(this.user.role) },
    direxNotifications() {
      if (!this.canViewDirexNotifications) return []; return this.direxInvoices.map(invoice => ({
        id: `direx-invoice-${invoice.id}`, title: `Facture Direx n°${String(invoice.id).padStart(4, '0')} impayée`, message: 'Cette facture Direx doit être payée.', meta: `${this.formatInvoicePeriod(invoice)} · ${this.formatCurrency(invoice.total_amount)}`,
      }))
    },
    inventoryNotifications() {
      if (!this.canViewInventoryNotifications || !this.inventoryReminder || !this.inventoryReminder.overdue) {
        return []
      }

      const overdueRepositories = (this.inventoryReminder.repositories || [])
        .filter(repository => repository.overdue)
        .map(repository => repository.name)
      if (overdueRepositories.length === 0) return []

      return [
        {
          id: 'inventory-overdue',
          title: 'Inventaire en retard',
          message: `Dépôt(s): ${overdueRepositories.join(', ')}`,
          meta: `Date ${this.inventoryReminder.date || '-'} - limite ${this.inventoryReminder.due_time || '-'}`,
        },
      ]
    },
    totalNotificationCount() {
      return (this.number || 0) + this.inventoryNotifications.length + this.direxNotifications.length
    },
  },
  watch: {
    storeUser: {
      immediate: true,
      handler(user) {
        this.user = user
        if (this.canViewSupportNotifications) {
          this.startNotificationPolling()
        } else {
          this.stopNotificationPolling()
        }
      },
    },
  },
  mounted() {
    this.checkApkAvailability()
  },
  beforeDestroy() {
    this.stopNotificationPolling()
  },
  methods: {
    async checkApkAvailability() {
      this.apkAvailable = false

      try {
        const separator = this.apkUrl.includes('?') ? '&' : '?'
        const response = await window.fetch(`${this.apkUrl}${separator}availabilityCheck=${Date.now()}`, {
          method: 'HEAD',
          cache: 'no-store',
        })
        const contentType = String(response.headers.get('content-type') || '').toLowerCase()

        // Vue/nginx can return index.html for an unknown static path. In that
        // case the request succeeds, but there is no APK available to download.
        this.apkAvailable = response.ok
          && !contentType.includes('text/html')
      } catch (error) {
        this.apkAvailable = false
      }
    },
    startNotificationPolling() {
      if (this.notificationPoller) return

      this.fetchSupportNotifications(true)
      this.notificationPoller = setInterval(this.fetchSupportNotifications, 10000)
      window.addEventListener('focus', this.fetchSupportNotifications)
      window.addEventListener('direx-invoices-updated', this.fetchSupportNotifications)
    },
    stopNotificationPolling() {
      if (this.notificationPoller) {
        clearInterval(this.notificationPoller)
        this.notificationPoller = null
      }
      window.removeEventListener('focus', this.fetchSupportNotifications)
      window.removeEventListener('direx-invoices-updated', this.fetchSupportNotifications)
      this.supportNotifications = []
      this.direxInvoices = []
      this.inventoryReminder = null
      this.number = 0
    },
    formatFn(date) {
      if (!date) {
        return null
      }
      const [year, month, day] = date.split('-')
      const day1 = day.substr(0, 2)
      const h = date.slice(11, 19)
      return `${year}-${month.padStart(2, '0')}-${day1.padStart(2, '0')} | ${h}`
    },
    formatRole(role) {
      const roleLabels = {
        admin: 'Administrateur',
        superadmin: 'Super Admin',
        manager: 'Responsable',
        supplier: 'Fournisseur',
        warehouse_operator: 'Opérateur',
        sales: 'Commercial',
        customer_support: 'Support Client',
        admin_developer: 'Développeur',
        accountant: 'Comptable',
      }
      return roleLabels[role] || role
    },
    truncateText(value, maxLength) {
      if (!value) return ''
      if (value.length <= maxLength) return value
      return `${value.slice(0, maxLength)}...`
    },
    formatInvoicePeriod(invoice) { const date = value => (value ? new Date(`${value}T00:00:00`).toLocaleDateString('fr-FR') : '-'); return `Du ${date(invoice.start_date)} au ${date(invoice.end_date)}` },
    formatCurrency(value) { return `${Number(value || 0).toLocaleString('fr-FR', { minimumFractionDigits: 3, maximumFractionDigits: 3 })} TND` },
    async fetchSupportNotifications(force = false) {
      if (this.notificationLoading && !force) return
      this.notificationLoading = true
      try {
        const notificationsRequest = axios.get('/api/support/notifications/', { params: { limit: 20 } })
          .catch(() => ({ data: { results: [], count: 0 } }))
        const reminderRequest = this.canViewInventoryNotifications
          ? axios.get('/api/inventory/reminder-status/')
            .catch(() => ({ data: null }))
          : Promise.resolve({ data: null })
        const direxRequest = this.canViewDirexNotifications ? axios.get('/api/invoices/invoice-providers/unpaid-notification/').catch(() => ({ data: { invoices: [] } })) : Promise.resolve({ data: { invoices: [] } })

        const [{ data }, { data: reminderData }, { data: direxData }] = await Promise.all([
          notificationsRequest,
          reminderRequest,
          direxRequest,
        ])
        this.supportNotifications = data.results || []
        this.number = data.count || this.supportNotifications.length
        this.inventoryReminder = reminderData
        this.direxInvoices = direxData.invoices || []
      } catch (error) {
        this.supportNotifications = []
        this.direxInvoices = []
        this.number = 0
        this.inventoryReminder = null
      }
      this.notificationLoading = false
    },
    async openSupportNotification(notification) {
      try {
        const { data } = await axios.post(`/api/support/notifications/${notification.id}/read/`)
        this.number = data.count || 0
        this.supportNotifications = this.supportNotifications.filter(item => item.id !== notification.id)
      } catch (error) {
        // Keep navigation usable even if marking the notification as read fails.
      }
      if (notification.price_change_request) {
        this.$router.push({ name: 'PriceChangeRequestList' })
        return
      }
      this.$router.push({ name: 'SupportTicketDetail', params: { id: notification.ticket } })
    },
    openInventoryNotification() {
      this.$router.push({ name: 'inventory-dashboard' })
    },
    openDirexNotification() { if (this.$route.name !== 'invoice-list-direx') this.$router.push({ name: 'invoice-list-direx' }) },
  },
  setup() {
    const perfectScrollbarSettings = {
      maxScrollbarLength: 60,
      wheelPropagation: false,
    }

    return {
      perfectScrollbarSettings,
    }
  },
}
</script>

<style scoped>
.apk-download-link {
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
  padding: 0.45rem 0.7rem !important;
  border-radius: 0.5rem;
  color: #5e5873;
  font-size: 0.8rem;
  font-weight: 600;
  transition: background-color 0.2s ease, color 0.2s ease;
}

.apk-download-link:hover,
.apk-download-link:focus {
  background-color: rgba(115, 103, 240, 0.12);
  color: #7367f0;
  text-decoration: none;
}

.scroll-area {
  max-height: 22rem;
}

.notification-item {
  gap: 0.75rem;
  padding: 0.9rem 1.25rem;
  color: #1f2937;
  border-bottom: 1px solid #eef2f7;
  text-decoration: none;
}

.notification-item:hover {
  background: #f8fafc;
  color: #111827;
}

.notification-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 2.25rem;
  height: 2.25rem;
  flex: 0 0 2.25rem;
  border-radius: 50%;
  background: #e8f4fd;
  color: #2563eb;
}

.inventory-notification-icon {
  background: #fff7ed;
  color: #c2410c;
}
.direx-notification { border-left: 3px solid #ea5455; }
.direx-notification-icon { background: #fde8e8; color: #d93025; }
.direx-notification .notification-heading, .direx-notification .notification-text, .direx-notification .notification-meta { color: #d93025; }

.notification-body {
  min-width: 0;
  flex: 1;
}

.notification-heading {
  font-weight: 700;
  color: #111827;
  line-height: 1.25;
}

.notification-text,
.notification-meta {
  color: #6b7280;
  font-size: 0.82rem;
  line-height: 1.35;
}

.notification-meta {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
  margin-top: 0.25rem;
}

.notification-empty {
  padding: 1.25rem;
  color: #6b7280;
  text-align: center;
}
</style>
